export { Deletion as DeletionModal } from './Deletion';
